// extracted by mini-css-extract-plugin
module.exports = {"news-tag":"eW","newsTag":"eW","dafalut":"eX","qishou":"eY","shangjia":"eZ","shehui":"e0","caiwu":"e1","piyao":"e2","suanfa":"e3","keji":"e4","lingshou":"e5","gongzuo":"e6"};